<template>
  <section class="section">

    <b-breadcrumb :items="[
        { text: this.customerName, to: '/' },
        { text: 'Indicatori', active: true },
        ]">
    </b-breadcrumb>

    <b-row>
      <b-col>
        <b-card title="Definizione indicatori">
          <div class="card-text">
            <b-list-group>
              <b-list-group-item v-for="(item, idx) in indicators" :key="idx" variant="light">
                <b-row>
                  <b-col sm="3">
                    <label>Nome indicatore *</label>
                    <b-form-input v-model="item.name" type="text" />
                  </b-col>
                  <b-col sm="2">
                    <label>Parametro *</label>
                    <b-form-input v-model="item.parameter" type="text" />
                  </b-col>
                  <b-col sm="2">
                    <label>Vettore</label>
                    <b-select v-model="item.vector" :options="vectorOptions"></b-select>
                  </b-col>
                  <b-col sm="4">
                    <div class="d-flex">
                      <b-form-group label="IPG">
                        <b-checkbox :unchecked-value="0" name="ipg" :value="1" v-model="item.ipg" />
                      </b-form-group>
                      <div class="ml-4">
                        <b-form-group label="KPI Alert">
                          <b-select v-model="item.alertYearBaseline" :options="kpiAlertOptions"></b-select>
                        </b-form-group>
                        <div v-if="item.alertYearBaseline">
                          <label>Scostamento max (%)*</label>
                          <b-input-group append="%">
                            <b-form-input v-model="item.alertMaxDeviation" type="text" />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col sm="1">
                    <b-button @click="remove(idx)">
                      <font-awesome-icon icon="times" />
                    </b-button>
                  </b-col>
                </b-row>
                <b-row v-show="false" style="padding-top:20px;padding-bottom:30px;">
                  <!--<b-col>
                    <label>Includi gruppi:</label>
                    <vue-tags-input
                      v-model="item.tag"
                      :tags="item.tags.map(t => { return { text: t } })"
                      @tags-changed="newTags => item.tags = newTags.map( t => t.text )"
                      :autocomplete-items="availableTags"
                      :add-only-from-autocomplete="true"
                      placeholder=""
                    />
                  </b-col>
                  <b-col>
                  <label>Includi siti:</label>
                    <vue-tags-input
                      v-model="item.site"
                      :tags="item.sites.map(t => { return { text: t.name } })"
                      @tags-changed="newTags => item.sites = newTags.map( t => { return { name: t.text, guid: t.guid } }  )"
                      :autocomplete-items="availableSites"
                      :add-only-from-autocomplete="true"
                      placeholder=""
                    />
                  </b-col>
                  <b-col>
                  <label>Escludi siti:</label>
                    <vue-tags-input
                      v-model="item.exclude"
                      :tags="item.excludeSites.map(t => { return { text: t.name } })"
                      @tags-changed="newTags => item.excludeSites = newTags.map( t => { return { name: t.text, guid: t.guid } }  )"
                      :autocomplete-items="availableSites"
                      :add-only-from-autocomplete="true"
                      placeholder=""
                    />
                  </b-col>
                  <b-col sm="1"></b-col>-->
                </b-row>
              </b-list-group-item>
              <b-list-group-item>
                <b-btn variant="primary" @click="addIndicator()">
                  <font-awesome-icon icon="plus" /> Aggiugi indicatore
                </b-btn>
                <b-btn variant="success" @click="save()">
                  <font-awesome-icon icon="save" /> Salva
                </b-btn>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-card>
      </b-col>
    </b-row>

  </section>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: "Indicators",
  components: {
    VueTagsInput
  },
  data() {
    return {
      indicators: [],
      tag: '',
      kpiAlertOptions: [
        { text: 'No', value: null },
        { text: 'Anno precedente', value: 'previous_year' },
      ]
    }
  },
  created() {
    const currentYear = new Date().getFullYear()
    for (let i = currentYear; i >= currentYear - 10; i--) {
      this.kpiAlertOptions.push({ text: i, value: i })
    }
    this.$store.dispatch("indicators/formulas").then(data => {
      this.indicators = data
    })
  },  
  computed: {
    user() {
      return this.$store.state.user
    },
    customerName() {
      return this.user.customerName
    },
    vectorOptions() {
      return this.$store.state.vectors.list.map( v => {
        return {  text: v.name, value: v.code }
      })
    },
    availableTags() {
      return this.$store.state.customers.selected.siteTags.map(t => { return { text: t } })
    },
    availableSites() {
      return this.$store.state.customers.selected.sites.map(s => { return { text: s.name, guid: s.guid } })
    }
  },
  watch: {
    customerIndicators(list) {
      this.indicators = _.cloneDeep(list)
    }
  },
  methods: {
    addIndicator() {
      this.indicators.push({ tags: [], alertYearBaseline: null, alertMaxDeviation: null, vector: 'EE' })
    },
    remove(idx) {
      this.indicators.splice(idx, 1)
    },
    async save() {      

      if (this.indicators.find(i => i.alertYearBaseline && !i.alertMaxDeviation)) { 
        this.$notify({
          type: "error",
          text: "Deviazione KPI non specificata",
          title: 'Errore'
        });
        return
      }

      if (this.indicators.find(i => !i.name || !i.parameter || !i.vector)) {
        this.$notify({
          type: "error",
          text: "Compilare tutti i campi obbligatori",
          title: 'Errore'
        });
        return
      }

      this.$store.commit("loading")

      let data = {
        list: this.indicators
      }
      try {
        const response = await this.$store.dispatch('indicators/edit', data)
        
        if (response.code != 1) {
          this.$notify({
            type: "error",
            text: response.message,
            title: 'Errore'
          });
        } else {
          this.$notify({
            type: "success",
            text: "Dati salvati",
            title: 'Successo'
          });
        }
      } catch (e) { 
        this.$notify({
          type: "error",
          text: e.message,
          title: 'Errore'
        });
      }
      this.$store.commit("stopLoading")
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Indicators.vue